import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { useEffect } from "react";

import { NewsletterBanner } from "@/components/NewsletterBanner";
import { NotificationBanner } from "@/components/NotificationBanner";
import useDialog, { DialogTheme } from "@/hooks/useDialog";
import useGlobalState from "@/hooks/useGlobalState";

import { Article, ArticleFooter } from "./components";

export const ArticlePage = ({ content, products }) => {
  const { t } = useTranslation();
  const { locale } = useRouter();
  const { hasSeenNewsletterBanner, seeNewsletterBanner } = useGlobalState();
  const { showDialog, dismissDialog } = useDialog();
  const includeBanner = content.includeBanner;

  useEffect(() => {
    if (!hasSeenNewsletterBanner) {
      const seconds50 = 50000;
      setTimeout(() => {
        showDialog(
          <NewsletterBanner dismiss={dismissDialog} />,
          null,
          "regular",
          DialogTheme.NEWSLETTER
        );
        seeNewsletterBanner();
      }, seconds50);
    }
  }, []);

  return (
    <>
      <Article content={content} />
      <ArticleFooter products={products} t={t} locale={locale} />
      {includeBanner ? <NotificationBanner breakout /> : null}
    </>
  );
};
